module.exports = __webpack_public_path__ + "static/cover_en-a51e9b17dbd22daea6363daa58f4cd5e.png";